import { log } from '@/log'
import { ApiProductclass } from '@/models/api/productclass'
import { ListWithPagination } from '@/models/api/response/list'
import { FkuQuery } from '@/services/api/item/fku/fku-query'
import { FkuUrl } from '@/services/api/item/fku/fku-url'
import AppId from '@/util/appid'
import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
import { ApiClient } from './client'
import { ApiService } from './service'

const namespace: string = 'productclass'

/**
 * TODO: root取得用のapi clientとfku取得用のapi clientを分ける
 * TODO: 生データではなくラップしたオブジェクトを利用するか、レスポンスデータのI/Fを明確に定義
 */
export default class ProductclassService extends ApiService {

  /**
   * {@link ApiProductclass} ではなく、レスポンスの生データを返却するので利用に注意
   */
  public async listFku(
    query: object
  ): Promise<Either<Error, any[]>> {
    return this.listFkuWithPagination(query).then((result) => {
      return result.map(listWithPagination => listWithPagination.list)
    })
  }

  /**
   * {@link ApiProductclass} ではなく、レスポンスの生データを返却するので利用に注意
   */
  public async listFkuWithPagination(
    query: object
  ): Promise<Either<Error, ListWithPagination<any>>> {
    try {
      const response = await ApiClient
        .get(FkuUrl.forCommon.withBrand(this.brand).list)
        .query(this.getNewQuery(query))

      log.debug({ service: `${namespace}/commonItemList`, response })

      return new Right(
        ListWithPagination.createFrom(response)
      )
    } catch (error) {
      return new Left(error)
    }
  }

  async getRootItem(id: string, query: any = {}): Promise<Either<Error, ApiProductclass>> {
    try {
      const response = await ApiClient
        .get(`/api/common-proxy/${this.appId}/productclass2/${id}`)
        .query(query)

      log.debug({ service: `${namespace}/getRootItem`, response })

      return new Right(new ApiProductclass(response.body.data))
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  public async getFkuWithSkuFromRootId(rootId: string): Promise<Either<Error, ApiProductclass[]>> {
    try {
      const response = await ApiClient
      .get(FkuUrl.forCommon.withBrand(this.brand).list)
      .query({
        belonging_to: rootId,
        with: 'part,stock~detail',
        root_id: rootId,
        'part.status_id': 1,
      })

      return new Right(
        _.map(response.body.data, item => new ApiProductclass(item))
      )
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  /**
   * {@link ApiProductclass} ではなく、レスポンスの生データを返却するので利用に注意
   */
  async listFkuBelongingToRoot(rootId: string, query: FkuQuery = FkuQuery.empty()): Promise<Either<Error, any[]>> {
    try {
      const response = await ApiClient
        .get(FkuUrl.forCommon.withBrand(this.brand).list)
        .query(query.addQuery({
          belonging_to: rootId,
          root_id: rootId,
          'part.status_id': 1,
        }).toObject())

      log.debug({ service: `${namespace}/listFkuBelongingToRoot`, response })

      return new Right(response.body.data)
    } catch (error) {
      return new Left(error)
    }
  }

  // TODO: Adohoc PJ_MYCOLOR-1099
  private getNewQuery(query: object) {

    const newQuery: object = query

    if (!('part.status_id' in query)) {
      // adhoc
      query['part.status_id'] = 1
    }

    if ('with' in newQuery) {
      const withs: string[] = newQuery['with'].split(',')
      if (_.indexOf(withs, 'indexsummary') < 0) withs.push('indexsummary')
      newQuery['with'] = withs.join(',')

    } else {
      newQuery['with'] = 'indexsummary'
    }

    return newQuery
  }

  private get brand(): string {
    return AppId.getBrandNameByAppId(this.appId)
  }
}
